import { PrimaryButton, Spinner, SpinnerSize, Stack } from "@fluentui/react";
import React from "react";
import { ActionButtonsProps } from "../../../Interfaces/PromptPlayground.interfaces";
import { playgroundClassNames as classNames, playgroundStyles as styles } from "../../../Styles";

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  disabled,
  hasResults,
  isExecuting,
  isSharing,
  onDownload,
  onExecute,
  onSaveSession,
  onShare
}) => {
  return (
    <div className={classNames.buttonRow}>
      <Stack horizontal tokens={{ childrenGap: 16 }}>
        <PrimaryButton
          onClick={onExecute}
          disabled={isExecuting}
          iconProps={{ iconName: "Send" }}
          styles={styles.buttonStyles}
        >
          {isExecuting ? (
            <>
              <span style={{ marginRight: 8 }}>Running</span>
              <Spinner size={SpinnerSize.xSmall} />
            </>
          ) : (
            "Run"
          )}
        </PrimaryButton>
        <PrimaryButton
          disabled={disabled}
          iconProps={{ iconName: "Save" }}
          onClick={onSaveSession}
          styles={styles.buttonStyles}
        >
          Save Session
        </PrimaryButton>
      </Stack>
      <Stack horizontal tokens={{ childrenGap: 16 }}>
        <PrimaryButton
          iconProps={{ iconName: "Download" }}
          text="Download Results"
          split
          disabled={!hasResults}
          menuProps={{
            items: [
              {
                key: "docx",
                text: "Download as DOCX",
                onClick: onDownload
              },
              {
                key: "email",
                text: "Send via Email",
                onClick: () => { },
                disabled: true
              }
            ]
          }}
          styles={styles.buttonStyles}
        />
        <PrimaryButton
          iconProps={{ iconName: "Share" }}
          disabled={!hasResults || isSharing}
          onClick={onShare}
          styles={styles.buttonStyles}
        >
          {isSharing ? (
            <>
              <span style={{ marginRight: 8 }}>Sharing</span>
              <Spinner size={SpinnerSize.xSmall} />
            </>
          ) : (
            "Share"
          )}
        </PrimaryButton>
      </Stack>
    </div>
  );
};
